import React, { useEffect, useState } from "react";
import AppointmentComponent from "../Components/Common/AppointmentComponent";
import BannerComponent from "../Components/Common/BannerComponent";
import BookAppointmentComponent from "../Components/Common/BookAppointmentComponent";
import servicDataService from "../services/ourServices";
import { imgUrl } from "../utilies/linkUrl";

const ServicesComponent = () => {
  const [services, setServices] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(()=>{
      window.scrollTo(0, 0);
      const servicesData= async()=>{
          setIsLoading(true);
          const service = await servicDataService()
          if(service) {
              setServices(service) ;
              setIsLoading(false);
          }else{
              setIsLoading(false);
          }

      }
      servicesData()
  },[])
  return (
    <>
      <BannerComponent title="Our-Service" subTitle="Service" />
      <section
        id="service-details2"
        className="service-details-two pt-120 pb-85 p-relative"
      >
        <div className="container">
          <div className="row">
            {
                services && services.length > 0 && services.map((service, idx) => (
                  <div className="col-lg-3 col-md-6 col-sm-12 mb-15" key={idx}>
                  <div className="card h-100">
                    <img
                      className="card-img-top"
                      src={`${imgUrl}${service.service_img}`} alt="dental service"
                      height="180"
                    />
                    <div className="card-body">
                  
                      <h4 className="card-title text-center"> {service.service_name?service.service_name:""}</h4>
                     
                    </div>
                  </div>
                </div>

                ))
            }

         
          </div>
        </div>
      </section>

<BookAppointmentComponent/>
    </>
  );
};

export default ServicesComponent;
